<script>
    import FormSwitchCheckbox from "../../components/forms/FormSwitchCheckbox.vue"
    import DropdownActions from '../../components/actions/DropdownActions'
    import FormModal from "../../components/modals/FormModal.vue"

    export default {
        components: { FormSwitchCheckbox, DropdownActions, FormModal },
        props: {
            ultraAdmins: Array
        },
        data() {
            return {
                showModal: false,
                modalTitle: null,
                fullName: null,
                email: null,
                phone: null,
                enterprisePartners: null,
            }
        },
        methods: {
            showDetails(itemDetails) {
                this.showModal = true
                this.modalTitle = 'View the details of ' + itemDetails.full_name
                this.fullName = itemDetails.full_name
                this.email = itemDetails.email
                this.phone = itemDetails.phone
                this.enterprisePartners = itemDetails.enterprisePartners
            },
            hideModal() {
                this.showModal = false
            },
            handleStatusActiveInactive(event, userId) {
                let status = 0;
                let statusMsg = 'Inactive Successfully!';
                if(event) {
                    status = 1;
                    statusMsg = 'Active Successfully!';
                }
                this.$inertia.post(
					route('admin-sb-status'),
					{
                        "mydata" : {
                            id: userId,
                            status: status,
                            platform: 'Vue'
                        }
                    },
					{
						onSuccess: (response) => {
							this.$toastr.s(statusMsg)
						},
						onError: (errors) => {
                            if(errors.message) {
							    this.$toastr.e(errors.message)
                            }
						}
					}
				)
            },
            onClickToLogin(userId) {
				this.$inertia.post(
					route('admin-login-as-ultra-admin'),
					{ user_id: userId },
					{
						onError: (errors) => {
                            if(errors.message) {
							    this.$toastr.e(errors.message);
                            }
						}
					}
				)
			},
        }
    }
</script>

<template>
    <div class="table-responsive">
        <table class="table project-list-table table-nowrap table-centered table-borderless align-middle">
            <thead>
                <tr>
                    <th scope="col">
                        Name
                    </th>
                    <th scope="col">
                        Email
                    </th>
                    <th scope="col">
                        Phone
                    </th>
                    <th scope="col">
                        Status
                    </th>
                    <th scope="col">
                        Actions
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in ultraAdmins" :key="item.id">
                    <td>
                        <a href="Javascript:void(0)" class="text-dark" @click="showDetails(item)">
                            <div class="d-flex">
                                <div class="flex-shrink-0 align-self-center me-3">
                                    <div v-if="item.image.length == 0" class="avatar-xs">
                                        <span class="avatar-title rounded-circle bg-primary bg-soft text-primary"> {{ item.nameFirstLetter | onlyFirstLetter }}</span>
                                    </div>
                                    <img v-else :src="item.image" class="rounded-circle avatar-xs" alt="">
                                </div>                                
                                <div class="flex-grow-1 overflow-hidden">
                                    <h5 class="text-truncate font-size-14 mb-1 mt-2">
                                        {{ item.full_name }}
                                    </h5>
                                </div>
                            </div>
                        </a>
                    </td>
                    <td>
                        <a :href="'mailto:' + item.email">
                            {{ item.email }}
                        </a>
                    </td>
                    <td>
                        <a :href="'tel:' + item.phone">{{ item.phone }}</a>
                    </td>
                    <td>
                        <FormSwitchCheckbox :id="'status' + item.id" v-model="item.status" name="status" label="" classes="" @input="handleStatusActiveInactive($event, item.id)" />
                    </td>
                    <td>
                        <DropdownActions 
                            classes="card-drop"
                            variant="white"
                            site="left"
                            toggleClasses="p-0"
                            menuClasses="dropdown-menu-end"
                        >
                            <i class="mdi mdi-dots-horizontal font-size-18" slot="buttonSlot"></i>
                            <b-dropdown-item href="Javascript:void(0)" @click="showDetails(item)">
                                <i class="bx bx-show-alt"></i>
                                View
                            </b-dropdown-item>
                            <b-dropdown-item :href="route('ultra-admin.edit', [item.id])">
                                <i class="bx bxs-pencil"></i>
                                Edit
                            </b-dropdown-item>
                            <b-dropdown-item href="Javascript:void(0)" @click="onClickToLogin(item.id)">
                                <i class="bx bx-log-in-circle"></i>
                                Login
                            </b-dropdown-item>
                            <b-dropdown-item :href="item.msgURL">
                                <i class="bx bx-message-rounded-dots"></i>
                                Message
                                <span v-if="item.isHaveMessage > 0" class="badge bg-danger ms-1">
                                    {{ item.isHaveMessage }}
                                </span>
                            </b-dropdown-item>
                        </DropdownActions>
                    </td>
                </tr>
            </tbody>
        </table>
        <FormModal
            :isShow="showModal"
            :title="modalTitle"
            :isShowSubmitButton="false"
            :isShowCancelButton="true"
            @hideModal="hideModal"
        >
            <div class="row">
                <div class="col-4">
                    <div class="mb-3">
                        Full Name:
                    </div>
                </div>
                <div class="col-8">
                    <div class="mb-3">
                        {{ fullName }}
                    </div>
                </div>
                <div class="col-4">
                    <div class="mb-3">
                        Email:
                    </div>
                </div>
                <div class="col-8">
                    <div class="mb-3">
                        {{ email }}
                    </div>
                </div>
                <div class="col-4">
                    <div class="mb-3">
                        Phone Number:
                    </div>
                </div>
                <div class="col-8">
                    <div class="mb-3">
                        {{ phone }}
                    </div>
                </div>
                <div class="col-12">
                    <div class="mb-3">
                        Enterprise Partners:
                    </div>
                </div>
                <div class="col-12">
                    <table v-if="enterprisePartners" class="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">
                                    Name
                                </th>
                                <th scope="col">
                                    Email
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="ep in enterprisePartners" :key="ep.id">
                                <td>{{ ep.enterprise_partners.name }}</td>
                                <td>{{ ep.enterprise_partners.email }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </FormModal>
    </div>
</template>